import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Icon from 'components/Icon';
import {
  TOPICAREASTHEMES,
  getTopicAreasThemeClassNames,
} from 'constants/topicAreasThemes';
import css from './TopicAreasNavigationBlock.module.scss';

const TopicAreasNavigationBlock = ({
  blockId,
  heading,
  theme = TOPICAREASTHEMES.lightGrey,
  items,
}) => (
  <div
    className={cn(css.block, getTopicAreasThemeClassNames(css, theme))}
    data-block={blockId}
  >
      {heading && <h2 className={cn("block-title-large", css.heading)}>{heading}</h2>}
      {items && (
          <ul className={css.items}>
            {items.map((item, index) => (
              <li className={css.item} key={index}>
                <a
                  className={cn(css.link, {
                    [css.active]: item.isActive,
                  })}
                  href={item.link.url}
                  target={item.link.openInNewWindow? "_blank" : null}
                  rel={item.link.openInNewWindow ? "noopener noreferrer" : null}
                >
                  {item.icon && <Icon icon={item.icon} className={css.icon} />}
                  <span className={css.linkText}>{item.link.linkText}</span>
                </a>
              </li>
            ))}
          </ul>
      )}
  </div>
);

TopicAreasNavigationBlock.propTypes = {
  blockId: PropTypes.number.isRequired,
  heading: PropTypes.string,
  theme: PropTypes.oneOf(
    Object.keys(TOPICAREASTHEMES).map((s) => TOPICAREASTHEMES[s])
  ),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      isActive: PropTypes.bool,
      link: PropTypes.shape({
        url: PropTypes.string.isRequired,
        linkText: PropTypes.string.isRequired,
        openInNewWindow: PropTypes.bool.isRequired,
      }),
    })
  ),
};

export default TopicAreasNavigationBlock;


// WEBPACK FOOTER //
// ./src/components/TopicAreasNavigationBlock/TopicAreasNavigationBlock.jsx